export default "__VITE_ASSET__KYuCoFVH__"